import { QuestionFolder } from '../question/question-folder';
import { TreeNode } from 'primeng/primeng';

/**
 * æä»¶å¤¹æ èç¹
 */
export class FolderTreeNode implements TreeNode {
  // å±æ§åç§ primeng p-tree TreeNode
  label?: string;
  data?: any;
  icon?: any;
  expandedIcon?: any;
  collapsedIcon?: any;
  children?: TreeNode[];
  leaf?: boolean;
  expanded?: boolean;
  type?: string;
  parent?: TreeNode;
  partialSelected?: boolean;
  styleClass?: string;
  draggable?: boolean;
  droppable?: boolean;
  selectable?: boolean;

  constructor(folder: QuestionFolder) { // ææ¶åªæå®ä½æä»¶å¤¹
    this.label = folder.name;
    this.data = folder;
    this.expandedIcon = 'fa fa-folder-open';
    this.collapsedIcon = 'fa fa-folder';
    this.children = [];
  }
}
